import { Copy } from '@grubhubprod/gh-cookbook-react';
import { Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { PageHeader } from 'src/components/selfService/layout/PageHeader/PageHeader';
import { PageTitle } from 'src/components/selfService/layout/PageTitle/PageTitle';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export function HomeHeader(): JSX.Element {
  const { user } = useAuth();
  const { isDesktop } = useScreenSizes();

  const title = `Welcome, ${user.first_name}`;

  const subtitle =
    'View credit usage, create and edit meal credits, and start group orders, all from your dashboard.';

  return (
    <Stack y={isDesktop ? 'lg' : 'md'}>
      <PageHeader y="sm">
        <PageTitle title={title} />
      </PageHeader>
      <Copy variant="body">{subtitle}</Copy>
    </Stack>
  );
}
